// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"36f1404e","349":"2e20c635","484":"211e6349","800":"c70746ed"}[chunkId] + ".css";
};